import { Box, Button } from '@mui/material'
import { useGetTreeById } from 'shared/hooks/trees/hooks'
import {
  getAllQuestions,
  removeAttachmentListsFromQuestions,
} from './utilities'

export function AddAudioFilesForEL({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const treeData = useGetTreeById({ treeId, versionId })
  const tree = treeData.tree

  if (!tree) return <Box>Loading...</Box>

  return (
    <Box>
      Page to add audio files for EL.
      <Button
        onClick={() => {
          getAllQuestions(tree)
        }}
      >
        Upload Audio Files
      </Button>
      <Button
        onClick={() => {
          removeAttachmentListsFromQuestions(tree)
        }}
      >
        Delete Attachment Lists from Questions
      </Button>
    </Box>
  )
}
